const e = {
  breakpoints: { mobile: 600, tablet: 999 },
  contentWidth: { large: "1024px" }
};
export {
  e as default
};
